import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    slides: [],
    slide: {},
    message: {},
}

const getters = {
    getAllSlides(state){
        return state.slides;
    },
    getSlide(state){
        return state.slide;
    },
    getSlideResponseMsg(state){
        return state.message;
    },
}

const mutations = {
     updateAllSlides(state, slides) {
        state.slides = slides
     },
     updateSlide(state, slide) {
        state.slide = slide
     },
     updateSlideResponseMsg(state, message) {
        state.message = message
     },
}

const actions = {
    ['LOAD_ALL_SLIDES']: ({commit}) => {
        return new Promise((resolve) => { 
        axios.get('slide',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllSlides', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

    ['CREATE_SLIDE']: ({commit}, data) => {
        return new Promise((resolve) => { 
        axios.post(`slide`, data,
            { headers: {'Content-Type': 'multipart/form-data' }
        }
        ).then(resp => {
            if(!resp.data.error){
                commit('updateSlideResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['GET_SLIDE']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.get(`/slide/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateSlide', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_SLIDE']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.delete(`/slide/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateSlideResponseMsg', resp.data.data)
                console.log(resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}